import { Pipe, PipeTransform } from "@angular/core";
import { ITrainingSession } from "@app/training/training.models";

@Pipe({ name: "educationSession" })
export class EducationSessionPipe implements PipeTransform {
	transform(sessions: ITrainingSession[], location: string): ITrainingSession[] {
		return sessions.filter(session => session.locationName === location);
	}
}
